import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '@/api/uiTranslations';

export const PACK_KEY = (lang: string) => ['ui-translations', lang] as const;

export function useUiPack(lang: string | null) {
  return useQuery({
    queryKey: PACK_KEY(lang ?? ''),
    queryFn: () => api.getPack(lang!),
    enabled: !!lang,
  });
}

export function useUpsertUiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lang, key, value }: { lang: string; key: string; value: string }) =>
      api.upsertKey(lang, key, value),
    onSuccess: (_d, vars) => qc.invalidateQueries({ queryKey: PACK_KEY(vars.lang) }),
  });
}

export function useDeleteUiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lang, key }: { lang: string; key: string }) => api.deleteKey(lang, key),
    onSuccess: (_d, vars) => qc.invalidateQueries({ queryKey: PACK_KEY(vars.lang) }),
  });
}
